import { GridSortItem } from "@mui/x-data-grid-pro"
import { PAGE_SIZE_DEFAULT } from "../../helpers"

export class DataState {
  page: number = 0;
  pageSize: number = PAGE_SIZE_DEFAULT;
  isLoading: boolean = false;
  sortModel: GridSortItem[] = [];
  reload: number = 0;
}
